import { Condition } from "@redotech/redo-model/return-flow/condition";
import { ReturnOptionMethod } from "@redotech/redo-model/return-flow/return-option";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";
import { getLabelForReturnOption } from "./return-method";

export interface CompensationMethodState {
  compensationMethod: ReturnOptionMethod["type"];
}

export const COMPENSATION_METHOD = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<CompensationMethodState>
  >,
): ConditionType<CompensationMethodState, Condition.CompensationMethod> => ({
  name: "Compensation method",
  description(state) {
    return `Compensation method = ${getLabelForReturnOption(
      state.compensationMethod,
    )}`;
  },
  Details(props: ConditionTypeDetailsProps<CompensationMethodState>) {
    return React.createElement(Details, props);
  },
  empty: { compensationMethod: ReturnOptionMethod.EXCHANGE },
  fromModel(model) {
    return { compensationMethod: model.compensationMethod };
  },
  toModel(state) {
    return {
      type: Condition.COMPENSATION_METHOD,
      compensationMethod: state.compensationMethod,
    };
  },
  valid(state) {
    return state.compensationMethod !== undefined;
  },
});
